// extracted by mini-css-extract-plugin
export default {"document-card":"document-card-259f","icon":"icon-a01d","small":"small-e492","bordered":"bordered-44f3","label":"label-a8fc","date":"date-9181"};